import { CreditSafeCompany, CreditSafePersonal } from "../Interfaces";

export const initialCreditSafePersonal: CreditSafePersonal = {
  entityNo: "",
  identyNo: "",
  name: "",
  address: "",
  postalCode: "",
  debitorType: "",
  timestamp: "",
  washProvider: "",
  scoringPoint: "",
  scoring: "",
  businessOwner: "",
  earnedIncomeAndBusiness: "",
  texebleIncome: "",
  totalIncome: "",
  finalTax: "",
  ropNumber: "",
  ropNumber1: "",
  debtNumber: "",
  debtSum: "",
  debtDate: "",
  bankruptcy: "",
  bankruptcyType: "",
  assessedValueBuilding: "",
  assessedValueLand: "",
  averageOwnedPartPercent: "",
  assessedValueOwnedPart: "",
};

export const initialCreditSafeCompany: CreditSafeCompany = {
  entityNo: "",
  identyNo: "",
  name: "",
  address: "",
  postalCode: "",
  debitorType: "",
  timestamp: "",
  washProvider: "",
  companyType: "",
  companyTypeText: "",
  rating: "",
  ratingText: "",
  riskPrognosis: "",
  limit: "",
  assessedValueTotal: "",
  assessedValueBuilding: "",
  assessedValueLand: "",
  averageOwnedPartPercent: "",
  assessedValueOwnedPart: "",
  payDbt: "",
  payInvoicesAvgValue: "",
  netTurnover: "",
  netProfit: "",
  profitDepriciation: "",
  currentAssets: "",
  fixtEquip: "",
  shortTermLiabs: "",
  longTermLiabs: "",
  quickRatio: "",
  skuldsattningsgrad: "",
  antalAnm: "",
  antalAnmAmal1: "",
  bankruptcyText: "",
  bankruptcyType: "",
};
